import { useEffect, useState } from "react";
import { apiJson } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";

export const useUnitOptions = () => {
  const [options, setOptions] = useState<string[]>([]);
  const { handle } = useMessageHandler();

  useEffect(() => {
    handle(async () => {
      const response = await apiJson.get("/mechanics/testpoints/units");
      setOptions(response.data);
    });
  }, []);

  return { options };
};